import React, { useState } from "react";

function Co(props) {
  const [co, setCo] = useState();
  const error = "Votre score doit être entre 331 et 699";
  const [nclcCO, setNclcCO] = useState("");
  function handler(e) {
    setCo(e.target.value);
  }
  const handleSubmit = (e) => {
    e.preventDefault();
    if (nclcCO !== error) {
      props.onSubmit(nclcCO);
    }
  };
  return (
    <div>
      <div className="Input">
        <span>Compréhension orale :</span>
        <form className="row" onSubmit={handleSubmit}>
          <input
            className="Score"
            type={"number"}
            placeholder={"Saisissez votre score en CO.."}
            onChange={handler}
          />
          <button
            type="submit"
            className="ButtonNCLC"
            onClick={() => {
              if (co >= 331 && co <= 368) {
                setNclcCO(4);
              } else if (co >= 369 && co <= 397) {
                setNclcCO(5);
              } else if (co >= 398 && co <= 457) {
                setNclcCO(6);
              } else if (co >= 458 && co <= 502) {
                setNclcCO(7);
              } else if (co >= 503 && co <= 522) {
                setNclcCO(8);
              } else if (co >= 523 && co <= 548) {
                localStorage.setItem("nclcCO", 9);
                setNclcCO(9);
              } else if (co >= 549 && co <= 699) {
                setNclcCO(10);
              } else {
                setNclcCO(error);
              }
            }}
          >
            NCLC
          </button>
          <h3 className="result">{nclcCO}</h3>
        </form>
      </div>
    </div>
  );
}

export default Co;
